export default "__VITE_ASSET__BuAXBGAp__"